module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-list"
  }, [(_vm.showIcon) ? _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt"
  })]) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('p', [_vm._v(_vm._s(_vm.description))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c7d543b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/EmptyList.vue
// module id = 549
// module chunks = 2